import './Card.css';

/**
 * Leistungskarte: Titel + Text, sonst nichts. Kein Icon, kein Bild - es gibt
 * ausser dem Logo kein Bildmaterial fuer diese Marke (siehe Briefing).
 */
export function Card({ title, text }: { title: string; text: string }) {
  return (
    <div className="card">
      <h3 className="card__title">{title}</h3>
      <p className="card__text">{text}</p>
    </div>
  );
}
